import { Sparkles } from "lucide-react";
import type { ReactNode } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../components/ui/tabs";
import { useUI } from "../../stores/ui";

interface AiPanelProps {
  title?: string;
  tabs?: Array<{ id: string; label: string; content: ReactNode }>;
  primaryAction?: ReactNode;
}

export function AiPanel({ title = "Panel IA", tabs, primaryAction }: AiPanelProps) {
  const state = useUI((s) => s.aiPanel);
  const setState = useUI((s) => s.setAiPanel);

  if (state === "hidden") return null;
  if (state === "rail") {
    return (
      <button
        type="button"
        onClick={() => setState("open")}
        className="grid w-8 cursor-pointer place-items-center border-l border-(--border-subtle) bg-(--bg-elevated) text-(--accent-500) hover:bg-(--bg-hover)"
        title="Expandir panel IA"
      >
        <Sparkles size={15} />
      </button>
    );
  }

  return (
    <aside className="flex w-80 flex-col gap-3 overflow-y-auto border-l border-(--border-subtle) bg-(--bg-elevated) p-4">
      <header className="flex items-center justify-between">
        <h3 className="text-sm font-semibold flex items-center gap-2">
          <Sparkles size={14} className="text-(--accent-500)" />
          {title}
        </h3>
        <button
          type="button"
          onClick={() => setState("rail")}
          className="text-xs text-(--text-tertiary) hover:text-(--text-primary)"
        >
          colapsar →
        </button>
      </header>

      {tabs && tabs.length > 1 ? (
        <Tabs defaultValue={tabs[0]?.id}>
          <TabsList className="w-full">
            {tabs.map((t) => (
              <TabsTrigger key={t.id} value={t.id} className="flex-1">
                {t.label}
              </TabsTrigger>
            ))}
          </TabsList>
          {tabs.map((t) => (
            <TabsContent key={t.id} value={t.id} className="text-sm">
              {t.content}
            </TabsContent>
          ))}
        </Tabs>
      ) : tabs && tabs.length === 1 ? (
        <div className="text-sm">{tabs[0]?.content}</div>
      ) : (
        <div className="text-sm text-(--text-secondary)">
          Selecciona una sección para ver resumen, relacionados y acciones.
        </div>
      )}

      {primaryAction && (
        <footer className="mt-auto border-t border-(--border-subtle) pt-3">{primaryAction}</footer>
      )}
    </aside>
  );
}
